import Image from '@/components/Image';

import type { OneRowFourNavProps } from './types';

const MAX_NAV_ITEMS = 5;

export default function OneRowFourNav({ indexData, moduleIndex }: OneRowFourNavProps) {
  // 新装修协议使用 content；同时兼容 Block Init 归一化后的扁平结构。
  const content = indexData.content ? { ...indexData, ...indexData.content } : indexData;
  const navigationItems = (content.jump_target || content.items || [])
    .map((item) => ({ ...item, imageSrc: item.jump_image || item.image || '' }))
    .filter((item) => item.imageSrc && item.title)
    .slice(0, MAX_NAV_ITEMS);

  if (navigationItems.length === 0) return null;

  return (
    <div
      className="w-full px-[24px] py-[8px]"
      style={{ backgroundColor: content.bg_color || '#f2f3f5' }}
    >
      <ul
        className="mx-auto grid w-full max-w-[1440px]"
        style={{ gridTemplateColumns: `repeat(${navigationItems.length}, minmax(0, 1fr))` }}
      >
        {navigationItems.map((item, index) => (
          <li
            key={item.id || `${item.title}-${index}`}
            className="flex min-w-0 items-center justify-center gap-[6px]"
          >
            <span className="flex size-[24px] shrink-0 items-center justify-center" aria-hidden>
              <Image
                src={item.imageSrc}
                alt=""
                width={24}
                height={24}
                loading={moduleIndex < 3 ? 'eager' : 'lazy'}
                className="block size-full object-contain"
              />
            </span>
            <span
              className="whitespace-nowrap font-br text-14 text-primary-black"
              style={item.text_color ? { color: item.text_color } : undefined}
            >
              {item.title}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
